module.exports = __webpack_public_path__ + "115fa0a8862f4be7e92e12e1848c4794.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-7.png
// module id = 1807
// module chunks = 0